// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.head-monitor {
  position: relative;
  display: flex;
  width: 100%;
  height: 10%;
  justify-content: center;
  align-items: center;
}

.head-line-monitor {
  width: 90%;
  position: absolute;
  left: 5%;
  top: 50%;
  color: #003757;
}

.menu-monitor {
  position: relative;
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
  height: 70%;

}

.compact-menu-list-monitor {
  position: relative;
  display: flex;
  width: 90%;
  height: 100%;
  left: 5%;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
  /* Distribuye el espacio entre los elementos */
  list-style-type: none;
  /* Elimina los estilos de viñetas de la lista */
  padding: 0;
  /* Elimina el relleno predeterminado de la lista */
  margin: 0;
  overflow: auto;
}

.compact-menu-list-monitor li {
  /* flex-grow: 1; Permite que los elementos ocupen el espacio disponible */
  min-width: 120px;
  width: auto;
  height: 50%;
  /* margin-right: 5px;
        margin-left: 5px; */
  background-color: transparent;
  border-right: 1px solid #a1a1a150;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-xSmall);
  cursor: pointer;
  /* color: rgba(195,195,195,1); */
  color: var(--third-color);
  text-align: center;
}

.compact-menu-list-monitor li:hover {
  background-color: var(--hover-color);
}

.compact-menu-list-monito .list-selected {
  /* background-color: rgba(195,195,195,1) !important; */
  background-color: var(--third-color) !important;
  /* color: rgb(1, 17, 31) !important; */
  color: var(--white-color) !important;
}

.cont-monitor {
  position: relative;
  display: block;
  width: 100%;
  height: 90%;
  /* background-color: rgb(95, 95, 95); */
}

.main-cont-graf-monitor {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.compact-graf-monitor {
  width: 95%;
  height: 95%;
  overflow: auto;
}

.edtTab:hover {
  height: 90%;
}

.css-9dn48z-singleValue {
  color: var(--txt-color) !important;
}

.css-at58ob-control {
  border-color: var(--second-color) !important;
}

/* NOC Minimalist Premium Header */
.pi-premium-header {
  position: relative;
  display: flex;
  width: 90%;
  height: 60px;
  margin: 0 auto;
  align-items: center;
  border-bottom: 2px solid #e2e8f0;
  /* margin-bottom: 20px; */
}

.pi-tabs-group {
  display: flex;
  gap: 16px;
  align-items: center;
  height: 100%;
}

.pi-tab-btn {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  padding: 0 20px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  font-family: inherit;
}

.pi-tab-btn:hover {
  background-color: #f8fafc;
  color: #0ea5e9;
  border-color: #cbd5e1;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}

.pi-tab-btn.active {
  background-color: #0ea5e9;
  color: #ffffff;
  border-color: #0ea5e9;
  box-shadow: 0 4px 6px -1px rgba(14, 165, 233, 0.2);
  font-weight: 600;
}

.pi-tab-btn.active::after {
  display: none;
}

.pi-dropdown-container {
  position: relative;
  display: flex;
  align-items: center;
  height: 38px;
}

.pi-tech-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 0 36px 0 16px;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  height: 100%;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease;
  min-width: 180px;
  font-family: inherit;
}

.pi-tech-select:hover {
  border-color: #94a3b8;
}

.pi-tech-select.active {
  background-color: #f0f9ff;
  border-color: #0ea5e9;
  color: #0ea5e9;
}

.pi-tech-select:focus {
  border-color: #0ea5e9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
}

.pi-select-icon {
  position: absolute;
  right: 12px;
  pointer-events: none;
  color: #64748b;
  font-size: 12px;
}

.pi-tech-select.active+.pi-select-icon {
  color: #0ea5e9;
}`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/styles/indicadores.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,WAAW;;AAEb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,8CAA8C;EAC9C,qBAAqB;EACrB,+CAA+C;EAC/C,UAAU;EACV,kDAAkD;EAClD,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,yEAAyE;EACzE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX;2BACyB;EACzB,6BAA6B;EAC7B,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sDAAsD;EACtD,+CAA+C;EAC/C,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".head-monitor {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 10%;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.head-line-monitor {\r\n  width: 90%;\r\n  position: absolute;\r\n  left: 5%;\r\n  top: 50%;\r\n  color: #003757;\r\n}\r\n\r\n.menu-monitor {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 70%;\r\n\r\n}\r\n\r\n.compact-menu-list-monitor {\r\n  position: relative;\r\n  display: flex;\r\n  width: 90%;\r\n  height: 100%;\r\n  left: 5%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  /* Distribuye el espacio entre los elementos */\r\n  list-style-type: none;\r\n  /* Elimina los estilos de viñetas de la lista */\r\n  padding: 0;\r\n  /* Elimina el relleno predeterminado de la lista */\r\n  margin: 0;\r\n  overflow: auto;\r\n}\r\n\r\n.compact-menu-list-monitor li {\r\n  /* flex-grow: 1; Permite que los elementos ocupen el espacio disponible */\r\n  min-width: 120px;\r\n  width: auto;\r\n  height: 50%;\r\n  /* margin-right: 5px;\r\n        margin-left: 5px; */\r\n  background-color: transparent;\r\n  border-right: 1px solid #a1a1a150;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: var(--font-size-xSmall);\r\n  cursor: pointer;\r\n  /* color: rgba(195,195,195,1); */\r\n  color: var(--third-color);\r\n  text-align: center;\r\n}\r\n\r\n.compact-menu-list-monitor li:hover {\r\n  background-color: var(--hover-color);\r\n}\r\n\r\n.compact-menu-list-monito .list-selected {\r\n  /* background-color: rgba(195,195,195,1) !important; */\r\n  background-color: var(--third-color) !important;\r\n  /* color: rgb(1, 17, 31) !important; */\r\n  color: var(--white-color) !important;\r\n}\r\n\r\n.cont-monitor {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  height: 90%;\r\n  /* background-color: rgb(95, 95, 95); */\r\n}\r\n\r\n.main-cont-graf-monitor {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.compact-graf-monitor {\r\n  width: 95%;\r\n  height: 95%;\r\n  overflow: auto;\r\n}\r\n\r\n.edtTab:hover {\r\n  height: 90%;\r\n}\r\n\r\n.css-9dn48z-singleValue {\r\n  color: var(--txt-color) !important;\r\n}\r\n\r\n.css-at58ob-control {\r\n  border-color: var(--second-color) !important;\r\n}\r\n\r\n/* NOC Minimalist Premium Header */\r\n.pi-premium-header {\r\n  position: relative;\r\n  display: flex;\r\n  width: 90%;\r\n  height: 60px;\r\n  margin: 0 auto;\r\n  align-items: center;\r\n  border-bottom: 2px solid #e2e8f0;\r\n  /* margin-bottom: 20px; */\r\n}\r\n\r\n.pi-tabs-group {\r\n  display: flex;\r\n  gap: 16px;\r\n  align-items: center;\r\n  height: 100%;\r\n}\r\n\r\n.pi-tab-btn {\r\n  background-color: #ffffff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #475569;\r\n  cursor: pointer;\r\n  padding: 0 20px;\r\n  height: 38px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s ease;\r\n  font-family: inherit;\r\n}\r\n\r\n.pi-tab-btn:hover {\r\n  background-color: #f8fafc;\r\n  color: #0ea5e9;\r\n  border-color: #cbd5e1;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.pi-tab-btn.active {\r\n  background-color: #0ea5e9;\r\n  color: #ffffff;\r\n  border-color: #0ea5e9;\r\n  box-shadow: 0 4px 6px -1px rgba(14, 165, 233, 0.2);\r\n  font-weight: 600;\r\n}\r\n\r\n.pi-tab-btn.active::after {\r\n  display: none;\r\n}\r\n\r\n.pi-dropdown-container {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  height: 38px;\r\n}\r\n\r\n.pi-tech-select {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  background-color: #f8fafc;\r\n  border: 1px solid #cbd5e1;\r\n  border-radius: 6px;\r\n  padding: 0 36px 0 16px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #334155;\r\n  height: 100%;\r\n  cursor: pointer;\r\n  outline: none;\r\n  transition: all 0.2s ease;\r\n  min-width: 180px;\r\n  font-family: inherit;\r\n}\r\n\r\n.pi-tech-select:hover {\r\n  border-color: #94a3b8;\r\n}\r\n\r\n.pi-tech-select.active {\r\n  background-color: #f0f9ff;\r\n  border-color: #0ea5e9;\r\n  color: #0ea5e9;\r\n}\r\n\r\n.pi-tech-select:focus {\r\n  border-color: #0ea5e9;\r\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);\r\n}\r\n\r\n.pi-select-icon {\r\n  position: absolute;\r\n  right: 12px;\r\n  pointer-events: none;\r\n  color: #64748b;\r\n  font-size: 12px;\r\n}\r\n\r\n.pi-tech-select.active+.pi-select-icon {\r\n  color: #0ea5e9;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
